import { Card, Grid, Typography } from "@mui/material";
import styles from "../ServicesMenu/services.module.scss";
import GridTableComponent from "../common/GridTableComponent/gridTableTemplate";
import { useNavigate } from "react-router-dom";
import CONSTANTS from "../../config/constants.json";
import { useRef } from "react";

const HumanServicesOverview = ({
  onPolicyClick,
}: {
  onPolicyClick: Function;
}) => {
  const navigation = useNavigate();
  const handleClick = () => {
    navigation("/humanservicesfaqs");
  };
  const handleClickpolicies = () => {
    onPolicyClick();
  };

  const handleNavigateHome = () => {
    navigation("/");
  };

  const ItemAddedData = [
    {
      Volunteers: "Venu Surakanti - Chairman",
    },
    {
      Volunteers: "Murali Swaminathan - President",
    },
    {
      Volunteers: "Venu Surakanti - Chairman",
    },
    {
      Volunteers: "Usha Ramaswamy - BOD Liaison",
    },
    {
      Volunteers: "Shyamala Venkateswaran- EC Chair",
    },
    {
      Volunteers: "Suman Jain",
    },
    {
      volunteers: "Padmaja Madhusudan",
    },
    {
      volunteers: "Saha Bode",
    },
    {
      volunteers: "Raji Ramakrishnan",
    },
    {
      volunteers: "Sathya Raghu",
    },
    {
      volunteers: "Pranati Manava",
    },
    {
      Volunteers: "Manoj Srivatsava",
    },
    {
      volunteers: "Jyothi Sarma",
    },
    {
      volunteers: "Anand Gundu",
    },
    {
      volunteers: "Vamsi Pulapa",
    },
    {
      volunteers: "Bhaskar Swaminathan",
    },
    {
      volunteers: "Geetha Haravu",
    },
    {
      volunteers: "Kamlesh Jain",
    },
  ];
  const ItemAddedDatatable = [
    {
      "Volunteering Physicians": "Dr. R Ravinder Kumar",
    },
    {
      "Volunteering Physicians": "Dr. James Patel",
    },
    {
      "Volunteering Physicians": "Dr. Kayal Sambandam",
    },
    { "Volunteering Physicians": "Dr. Vuppa Ramesh" },
    { "Volunteering Physicians": "Dr. Arunasri Kelleti" },
    { "Volunteering Physicians": "Dr. Neel Palakurthy" },
    { "Volunteering Physicians": "Dr. Yasminah Shabbar" },
    { "Volunteering Physicians": "Dr. Sharda Patel" },
    { "Volunteering Physicians": "Dr. Chitgopekar" },
    { "Volunteering Physicians": "Dr. Uma Patel" },
    { "Volunteering Physicians": "Dr. Ratika Sharma" },
    { "Volunteering Physicians": "Dr. Manjula Reddy" },
    { "Volunteering Physicians": "Dr. Murali Golconda" },
    { "Volunteering Physicians": "Dr. Kiran Kapila" },
    { "Volunteering Physicians": "Dr. Rishi Kapila" },
    { "Volunteering Physicians": "Dr. Sampath Ramakrishana" },
    { "Volunteering Physicians": "Dr. Sankari Kasi" },
    { "Volunteering Physicians": "Dr. Elena Lopez" },
    { "Volunteering Physicians": "Jyoti Saboo - Physical Therapist" },
    { "Volunteering Physicians": "Surekha Pol - Physical Therapist" },
    { "Volunteering Physicians": "Asha Bajaj - Physical Therapist" },
    { "Volunteering Physicians": "Mala Seshagiri - Nutritionist" },
    { "Volunteering Physicians": "Rini Johar - Homeopathy" },
    { "Volunteering Physicians": "Dhira Gupta - Ayurveda" },
    { "Volunteering Physicians": "Bhuvana Himakuntala" },
    { "Volunteering Physicians": "Rashana Sharma" },
    { "Volunteering Physicians": "Dr. Namitha Agarwal" },
    { "Volunteering Physicians": "Dr. Sneha Kishore" },
    { "Volunteering Physicians": "Preeti Gupta Ayurveda" },
  ];
  const ItemAddedtable = [
    {
      "Volunteering Non-Profit Organisations": "South Asian Heart Association",
    },
    {
      "Volunteering Non-Profit Organisations": "Samaj Saves Lives",
    },
    {
      "Volunteering Non-Profit Organisations": "Dr. Kayal Sambandam",
    },
    {
      "Volunteering Non-Profit Organisations":
        "Stanford Asian Liver Cancer Center",
    },
    {
      "Volunteering Non-Profit Organisations":
        "US 2020 Census Recruiting Awareness",
    },
    {
      "Volunteering Non-Profit Organisations": "National Bone Marrow Institute",
    },
  ];
  const columnMapping = {
    Volunteers: "Volunteers",
  };
  const columnMappingvolunteer = {
    "Volunteering Physicians": "Volunteering Physicians",
  };
  const columnMappingvoulnteers = {
    "Volunteering Non-Profit Organisations":
      "Volunteering Non-Profit Organisations",
  };

  const volunteersRef = useRef<HTMLDivElement>(null);

  // Function to scroll to the Volunteers component
  const scrollToVolunteers = () => {
    if (volunteersRef.current) {
      volunteersRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNavigate = () => {
    navigation("/faqs");
    setTimeout(() => {
      const faqSection = document.getElementById("faqSection");
      if (faqSection) {
        window.scrollTo({ top: 1320, behavior: "smooth" });
        faqSection.click()
      }
    }, 50);
  };
  

  const aboutUs = (): React.ReactElement => {
    return (
      <>
        <Typography className={styles.header}>About Us</Typography>
        <Grid>
          <Typography className={styles.content}>
            Serving the community at large by making a difference in the lives
            of needy people is one of the important functions of the HCCC{" "}
            <span className={styles.textcolor} onClick={handleNavigateHome}>
              (Hindu Community and Cultural Center).
            </span>
            Such activities are covered under Human Services. The HCCC strongly
            preaches in "Serving God by Serving Humanity" and practices it as
            its motto. In the past years, several social programs were
            successfully executed on different occasions. These activities range
            from assisting needy people and supporting student education
            activities to providing relief for victims of natural disasters. The
            Human Services committee organizes such programs with the help of
            kind-hearted donors and dedicated volunteers, who are willing to
            donate their time and resources for such noble causes. If you could
            spare a few hours a week and donate your valuable time{" "}
            <span className={styles.textcolor} onClick={scrollToVolunteers}>
              Volunteer
            </span>{" "}
            or resources{" "}
            <span className={styles.textcolor} onClick={handleNavigate}>
              Donations
            </span>{" "}
            to serve the community, we warmly welcome you onboard.
          </Typography>
        </Grid>
      </>
    );
  };
  const projects = (): React.ReactElement => {
    return (
      <>
        <Grid>
          <Typography className={styles.header}>Projects</Typography>
        </Grid>
        <Typography className={styles.content}>
          The scope of the projects conducted is mostly limited by the available
          resources. However, all projects and events require pre-approval by
          the HCCC board and will be conducted with in the frame work of its{" "}
          <a className={styles.colorlink} onClick={handleClickpolicies}>
            policies.
          </a>
          The following is a list of projects identified by the Human Services.
          Every year some of these projects or events are being executed
          routinely based upon the need for specific occasion and available
          resources and space. The committee appreciates motivated individuals
          identifying and conducting similar projects in different areas of
          public need and interest.
          <ul className={styles.secondcontent}>
            <li>Food programs for the needy</li>
            <li>Distribution of clothing, blankets, and toys.</li>
            <li>Senior activities and program for seniors.</li>
            <li>
              Support to other non-profit organizations dedicated to human
              services ....{" "}
              <a
                href={
                  CONSTANTS.DOMAIN_URL +
                  "/hints/content/html/2022/2022-GIA-application-form.pdf"
                }
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
                className={styles.colorlink}
              >
                Application
              </a>
            </li>
            <li>
              Thanksgiving and Christmas Dinner (Livermore and in Bay area)
            </li>
            <li>
              Health Advisory and Education Center on HCCC Premises ....
              <span onClick={handleClick} className={styles.colorlink}>
                FAQ’s.
              </span>
            </li>
            <li>Health classes such as Yoga and/or meditation.</li>
            <li>Health drives such as blood donation and bone marrow.</li>
            <li>
              Donation of learning material to schools and libraries such as
              computers and books.
            </li>
            <li>Scholarships for gifted but needy students globally.</li>
            <li>Donations to victims of Natural Disaster globally.</li>
            <li>Funeral Services for devotees upon request.</li>
            <li>Prayer or Puja for critically ill upon request.</li>
          </ul>
        </Typography>
      </>
    );
  };
  const volunteers = (): React.ReactElement => {
    return (
      <div ref={volunteersRef}>
        <Grid>
          <Typography className={styles.header}>Volunteers</Typography>
        </Grid>
        <Typography className={styles.content}>
          The Human Services Committee would to like to express our deepest
          appreciation and gratitude to those who have volunteered and are
          providing their services and untiring support in the hope of assisting
          the communities locally and globally. We are continually looking for
          volunteers and volunteering physicians to support our activities in
          the areas of project execution, fund raising and health advisory. The
          following is a list of a few of our volunteers. If you would like to
          be volunteer you are most welcome and your service is appreciated.
        </Typography>
        <Grid xs={12} sm={3} className={styles.table}>
          <div className={styles.tableContainer}>
            <div className={styles.tableWrapper}>
              <GridTableComponent
                tableData={ItemAddedData}
                columnMapping={columnMapping}
              />
            </div>
            <div className={styles.tableWrapper}>
              <GridTableComponent
                tableData={ItemAddedDatatable}
                columnMapping={columnMappingvolunteer}
              />
            </div>
            <div className={styles.tableWrapper}>
              <GridTableComponent
                tableData={ItemAddedtable}
                columnMapping={columnMappingvoulnteers}
              />
            </div>
          </div>
        </Grid>
      </div>
    );
  };
  return (
    <div className={styles.overviewLayout}>
      <Card className={styles.cardContainer}>
        {aboutUs()}
        {projects()}
        {volunteers()}
      </Card>
    </div>
  );
};
export default HumanServicesOverview;
